// extracted by mini-css-extract-plugin
module.exports = {"container":"Experience_container__xyKnF","icon_container":"Experience_icon_container__I2v_B","text_container":"Experience_text_container__D7yl_"};